import { useEffect } from 'react';
import Header from './Header';
import Hero from './Hero';
import TrustBar from './TrustBar';
import Programme from './Programme';
import Benefits from './Benefits';
import Faq from './Faq';
import Location from './Location';
import RsvpForm from './RsvpForm';
import Footer from './Footer';
import StickyCta from './StickyCta';
import { trackStandard } from '../../lib/pixel';
import { trackPostHog } from '../../lib/analytics';
import { useScrollDepth } from '../../lib/useScrollDepth';
import './portes-ouvertes.css';

const PortesOuvertesPage = () => {
  useScrollDepth('jpo-portes-ouvertes');

  useEffect(() => {
    trackStandard('ViewContent', {
      content_name: 'jpo-portes-ouvertes',
      content_category: 'landing',
    });
    trackPostHog('view_landing', {
      page: 'jpo-portes-ouvertes',
    });
  }, []);

  return (
    <div className="jpo-root">
      <Header />
      <Hero />
      <TrustBar />
      <Programme />
      <Benefits />
      <Faq />
      <Location />
      <RsvpForm />
      <Footer />
      <StickyCta />
    </div>
  );
};

export default PortesOuvertesPage;
